<div class="content pb-6 center">
  <div class="w-100 d-flex flex-column align-items-start">
    <h1 class="h5 mb-4 text-center w-100">
      Your Kubernetes platform.
      <br />
      <span style="color: var(--bs-primary)">Built for the age of AI.</span>
    </h1>

    <div class="d-flex flex-column gap-3 ms-3 list-item-wrapper">
      <span class="list-item gap-1">
        <i class="pi pi-arrow-right text-success" style="font-size: 17px" aria-hidden="true"></i>
        <div>Multi-cluster management on any Kubernetes</div>
      </span>
      <span class="list-item gap-1">
        <i class="pi pi-arrow-right text-success" style="font-size: 17px" aria-hidden="true"></i>
        <div>Self-service workspaces and golden paths</div>
      </span>
      <span class="list-item gap-1">
        <i class="pi pi-arrow-right text-success" style="font-size: 17px" aria-hidden="true"></i>
        <div>Agentic Kubernetes operations</div>
      </span>
      <span class="list-item gap-1">
        <i class="pi pi-arrow-right text-success" style="font-size: 17px" aria-hidden="true"></i>
        <div>Access control and governance</div>
      </span>
    </div>

    <div class="w-100 border-top border-bottom py-5 mt-6 d-flex flex-column center">
      <div class="caption w-100 text-center mb-5">Trusted by</div>

      <div
        class="d-flex partners w-100 flex-wrap align-items-center gap-5 justify-content-center"
        style="max-width: 390px"
      >
        <img src="assets/logos/partners2/AS-logo.svg" alt="Alstin" />
        <img src="assets/logos/partners2/BIG_direkt_Logo.svg" alt="BIG direkt gesund" />
        <img src="assets/logos/partners2/EMS-logo.svg" alt="EasyMotionSkin" />
        <img src="assets/logos/partners2/SCS-logo.svg" alt="smart city system" />
        <img src="assets/logos/partners2/Koelner_Verkehrs-Betriebe_AG_logo.svg" alt="KVB" />
        <img src="assets/logos/partners2/neele-vat-logo.svg" alt="Neele-Vat" />
        <img src="assets/logos/partners2/REWEDigital_Logo.svg" alt="REWE digital" />
        <img src="assets/logos/partners2/reference_logo_offolio.svg" alt="Offolio" />
        <img src="assets/logos/partners2/Logo_plusserver.svg" alt="plusserver" />
      </div>
    </div>
  </div>
</div>
